import React, { useState, Fragment, useEffect } from 'react';
import { Tooltip } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import categoryBotResponseCodeMapping from '../../../../../../data/categoryBotResponseCodeMapping';
import drBotResponseCodeMapping from '../../../../../../data/drBotResponseCodeMapping';
import accoBotResponseCodeMapping from '../../../../../../data/accoBotResponseCodeMapping';
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  FormGroup,
} from 'reactstrap';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import {
  AxiosAPI,
  getUserID,
  getGroupID,
} from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Internal_Property_By_Id,
  gAPI_Users_By_Id,
  gAPI_Vouchers_List,
  postAPI_Create_Services,
  gAPI_Service_By_Id,
  putAPI_Update_Service,
  putAPI_Delete_Service,
  API_Media_Upload,
  gAPI_FormsBy_PropertyId,
  gAPI_EventsList,
  gAPI_QuestionSets,
  gAPI_GuestPassList,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import ImageGallery from '../../gallery/index';
import IconGallery from '../../icon-gallery/index';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faEdit } from '@fortawesome/free-solid-svg-icons';
import {
  categoriesData,
  salonCategoriesData,
  AccommodationCategoriesData,
  DoctorServicesCategoriesData,
  GuestServicesCategoriesData,
} from '../../../../../../data/ServiceCategories';
import Appearance from '../../messenger/components/Appearance';
import CategoryTag from './CategoryTag';
import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
const guestLifeCycleList = [
  { label: 'Pre Booking', value: 'Pre Booking' },
  { label: 'Pre Check-in', value: 'Pre Check-in' },
  { label: 'At Property', value: 'At Property' },
  { label: 'After Check-out', value: 'After Check-out' },
  { label: 'Member Specific', value: 'Member Specific' },
];
const suitabilityData = [
  { label: 'Business Traveler', value: 'Business Traveler', key: 0 },
  { label: 'Vacationing Families', value: 'Vacationing Families', key: 1 },
  { label: 'Couples', value: 'Couples', key: 2 },
  { label: 'Solo Traveler', value: 'Solo Traveler', key: 3 },
  { label: 'Friends or a Group', value: 'Friends or a Group', key: 4 },
];
export function AddNewService({
  id,
  visible,
  toggleModal,
  formLabel,
  isServiceOrder,
  propertyId,
  domains,
  isHostedPage,
  locale,
  allAddonCategoryData,
  allMembershipGroupData,
  LoadData,
  languageCode,
}) {
  const [titleToolTip, settitleToolTip] = useState(false);
  const [typeToolTip, setTypeToolTip] = useState(false);
  const [priceToolTip, setpriceToolTip] = useState(false);
  const [categoryToolTip, setCategoryToolTip] = useState(false);
  const [globelToolTip, setGlobelToolTip] = useState(false);
  const [selectedOptions, setselectedOptions] = useState([]);
  const [selectedcategories, setselectedcategories] = useState([]);
  const [isDoctor, setIsDoctor] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [iconGalleryVisible, setIconGalleryVisible] = useState(false);
  const [qbot, setQbot] = useState(false);
  const [isAccommodation, setIsAccommodation] = useState(false);
  const [selectedSuitability, setSelectedSuitability] = useState([]);
  const [lifeCycle, setLifeCycle] = useState(guestLifeCycleList);
  const [isAivaProperty, setIsAivaProperty] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [guestServiceCategory, setGuestServiceCategory] = useState(
    GuestServicesCategoriesData
  );
  const [addTagModel, setAddTagModel] = useState(false);
  const [ownTag, setOwnTag] = useState('');
  const [addonCategoryData, setAddonCategoryData] = useState([
    { label: 'Add New', value: 'Add own tag', key: -1 },
  ]);
  const [membershipGroupData, setMembershipGroupData] = useState([
    { label: 'Add New', value: 'Add own tag', key: -1 },
  ]);
  const [ApiState, setApiState] = useState('default');
  const [selectedMembershipGroup, setSelectedMembershipGroup] = useState([]);
  const [isCategoryTag, setIsCategoryTag] = useState(false);
  const [isMembershipGroup, setIsMembershipGroup] = useState(false);
  const [formsData, setFormsData] = useState([]);
  const [errorModel, setErrorModel] = useState({ isVisible: false, msg: '' });
  const [addCategoryTagModel, setAddCategoryTagModel] = useState(false);
  const [isEditCategory, setIsEditCategory] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [isIframe, setIsIframe] = useState(false);
  const [isIframeTop, setIsIframeTop] = useState(false);
  const [eventsData, setEventsData] = useState([]);
  const [conversationFlowList, setConversationFlowList] = useState([]);
  const [guestLocation, setGuestLocation] = useState([]);
  const [files, setFiles] = useState([]);
  const [isAgree, setAgree] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [fileErrorMsg, setFileErrorMsg] = useState('');
  const [fileError, setFileError] = useState();
  const [fileUpload, setFileUpload] = useState(false);
  let fileObj = [];
  const handleFileUploadToggle = () => setFileUpload(!fileUpload);
  const handleFileToggle = () => {
    setFileError(!fileError);
  };
  const typeTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Service</b> is one service like Dental Exam & Xray.
          <br /> <b>Package </b> is a service bundle offering multiple services
          for sale as a one combined service package.
          <br /> <b>Special Offer </b> is certain special value you can offer to
          your client.
        </Tooltip>
      );
    } else if (qbot) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Room Service</b> is a food or beverage order that a guest can place
          to be delivered to the room.
          <br /> <b>Housekeeping</b> is something guest can ask for the room,
          like cleaning, replacing towels, toiletries etc.
        </Tooltip>
      );
    } else if (isAccommodation) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Service or Activity</b> are additional things you promote and sell,
          e.g. Golf, Spa, Ski and others.
          <br />
          <b>Amenity</b> are included things e.g. a Swimming pool.
          <br />
          <b>Aiva voucher</b> are vouchers you promote with{' '}
          <a
            href="www.getaiva.com"
            className="btn-link"
            style={{ textDecoration: 'underline', fontWeight: 'bold' }}
          >
            {' '}
            aiva{' '}
          </a>
          <br />
          <b>Retail</b> are shops in your premises.
          <br />
          <b>Product</b> are physical products you promote and sell
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Service</b> is one service like haircut, hair color and head
          message.
          <br /> <b>Package</b> is service bundle offering multiple services for
          sale as one combined service package.
          <br /> Special <b>Offer</b> is certain special value you can offer to
          your client.
        </Tooltip>
      );
    }
  };
  const titlePlaceholderText = () => {
    if (isDoctor) {
      return 'e.g. Shuttle Service';
    } else if (qbot) {
      return 'e.g. Shuttle Service';
    } else if (isAccommodation) {
      return 'e.g. Shuttle Service';
    } else {
      return '$179 for Hair cut & colouring';
    }
  };

  const priceChangeTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and
          depends on the specific needs.
        </Tooltip>
      );
    } else if (qbot) {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and depend
          upon different conditions like{' '}
          {isServiceOrder
            ? 'day of the week and time spent.'
            : 'hair length, thickness etc.'}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and depend
          upon different conditions like{' '}
          {isAccommodation
            ? 'day of the week and time spent.'
            : 'hair length, thickness etc.'}
        </Tooltip>
      );
    }
  };

  const categoryTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={categoryToolTip}
          target="categoryToolTip"
          toggle={toggleCategoryToolTip}
        >
          Select the closest one or multiple categories that apply to this
          service, package or offer.
        </Tooltip>
      );
    }
  };

  const generatorCategorySelect = () => {
    if (isDoctor) {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={DoctorServicesCategoriesData}
        />
      );
    } else if (qbot) {
      if (isServiceOrder === true) {
        return (
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            isMulti={true}
            name="form-field-name"
            value={selectedOptions}
            onChange={handleChangeMulti}
            options={guestServiceCategory}
          />
        );
      } else {
        return (
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            isMulti={true}
            name="form-field-name"
            value={selectedOptions}
            onChange={handleChangeMulti}
            options={GuestServicesCategoriesData}
          />
        );
      }
    } else if (isAccommodation) {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMultiAcc}
          options={addonCategoryData}
        />
        // <Select
        //   components={{ Input: CustomSelectInput }}
        //   className="react-select"
        //   classNamePrefix="react-select"
        //   isMulti={true}
        //   name="form-field-name"
        //   value={selectedOptions}
        //   onChange={handleChangeMulti}
        //   options={AccommodationCategoriesData}
        // />
      );
    } else {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={salonCategoriesData}
        />
      );
    }
  };

  // useEffect(() => {
  //   if (id !== undefined) {
  //     console.log('in');
  //     AxiosAPI({
  //       method: 'get',
  //       url: `${gAPI_Service_By_Id}/${id}`,
  //     })
  //       .then((res) => {
  //         setServiceData(res.data);
  //         var selectedcategories = [];
  //         try {
  //           res.data.categories.map((item) =>
  //             selectedcategories.push(
  //               categoriesData.filter((cat) => cat.value === item)[0]
  //             )
  //           );
  //         } finally {
  //         }
  //         setselectedOptions(selectedcategories);
  //         setselectedcategories(selectedcategories);
  //       })
  //       .catch((err) => console.log('err', err));
  //   }
  // }, [qbot, isDoctor]);

  if (Array.isArray(domains) && qbot === false && isServiceOrder !== true) {
    // console.log("domains", domains);
    domains.forEach((r) => {
      if (r.type === 'QuarantineBot') {
        setQbot(true);
      }
    });
  }

  // if (Array.isArray(domains) && isDoctor === false && isServiceOrder !== true) {
  //   // console.log("domains", domains);
  //   domains.forEach((r) => {
  //     if (r.type === 'Doctors') {
  //       setIsDoctor(true);
  //     }
  //   });
  // }
  if (
    Array.isArray(domains) &&
    isAccommodation === false &&
    isServiceOrder !== true
  ) {
    //console.log("domains", domains);
    domains.forEach((r) => {
      if (
        r.type === 'AccommodationProviders' ||
        r.type === 'AccommodationProvidersGroup' ||
        r.type === 'HolidayHomes' ||
        r.type === 'HolidaysPark' ||
        r.type === 'Doctors' ||
        r.type === 'Activities' ||
        propertyId === '-1'
      ) {
        setIsAccommodation(true);
      }
    });
  }

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const toggleIconGallery = () => {
    setIconGalleryVisible(!iconGalleryVisible);
  };
  const selectedImage = (image) => {
    setServiceData({
      ...serviceData,
      imageLink: image.src,
    });
  };

  const handleRemoveImage = () => {
    setServiceData({
      ...serviceData,
      imageLink: '',
    });
  };

  const selectedIcon = (image) => {
    setServiceData({
      ...serviceData,
      iconLink: image.src,
    });
  };
  const handleRemoveIcon = () => {
    setServiceData({
      ...serviceData,
      iconLink: '',
    });
  };
  const handleRemoveMedia = () => {
    AxiosAPI({
      method: 'Delete',
      url: `${API_Media_Upload}`,
      data: {
        file: serviceData?.media,
        folder: 'bmbgallery',
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(
      (res) => {
        setServiceData({
          ...serviceData,
          media: '',
        });
      },
      (error) => {
        //  setApiState('fail')
        console.log('eee.data', error.data);
      }
    );
  };
  const [serviceData, setServiceData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    type: 'Package',
    title: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    displayText: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    conditions: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    status: 'Active',
    currency: 'NZD',
    priceRangeStart: 0,
    priceRangeEnd: 0,
    taxIncluded: true,
    categories: [],
    displayOrder: 1,
    creator: 'dashboard',
    imageData: '',
    imageLink: '',
    luisIntent: '',
    luisEntityKey: '',
    luisEntityValue: '',
    discount: 0,
    discountedPrice: 0,
    discountedPriceEnd: 0,
    taxPercentage: 0,
    taxAmount: 0,
    bookingMethod: 0,
    offerDiscount: false,
    promoCode: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    instructions: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    externalUrl: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    voucherId: '',
    voucherName: '',
    guestLifeCycle: [],
    suitability: [],
    serviceType: 'AddOnUpsells',
    membershipGroup: [],
    isGlobal: false,
    highlightItem: false,
    formId: '',
    formName: '',
    submitButtonText: [],
    appearance: null,
    iconLink: '',
    useImageAsVideoThumbnail: false,
    categoryId: [
      {
        id: '',
        languageCode: languageCode,
      },
    ],
    embedIframe: '',
    embedIframeTop: '',
    forms: [],
    conversationFlow: [],
  });

  useEffect(() => {
    let guestCategoryList = [...GuestServicesCategoriesData];
    if (isServiceOrder === true) {
      setQbot(true);
      setIsDoctor(false);
      setIsAccommodation(false);
      setGuestServiceCategory(guestCategoryList);
    }
    if (propertyId != undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Vouchers_List}?groupId=${getGroupID()}&propertyId=${propertyId}&languageCode=${languageCode}&search=&status=All&pageNumber=${1}&pageSize=${100}&email=${
            res.data.email
          }`,
        }).then((res) => {
          if (
            res.data.vouchers !== undefined &&
            res.data.vouchers !== null &&
            res.data.vouchers.length > 0
          ) {
            var voucherData = res.data.vouchers.filter(
              (item) => item.status !== 'Draft'
            );
            setVouchers(voucherData);
          }
        });
      });
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setIsAivaProperty(res.data.isAiva);
        })
        .catch((err) => console.error(err));
      AxiosAPI({
        method: 'get',
        url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${languageCode}`,
      })
        .then((res) => {
          setFormsData(res.data);
        })
        .catch((err) => console.error(err));
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_EventsList}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${languageCode}&orderBy=&search=`,
    }).then((res) => {
      var list = res.data.sort((a, b) => a.displayOrder - b.displayOrder);
      setEventsData(list);
    });
    AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${languageCode}`,
    })
      .then((res) => {
        setConversationFlowList(
          res.data.sets.filter((x) => x.type === 'ConversationFlow')
        );
      })
      .catch((err) => {
        console.log(err);
      });
    const categoryOptions = addonCategoryData;
    if (isAccommodation === true) {
      if (
        allAddonCategoryData !== undefined &&
        allAddonCategoryData.length > 0
      ) {
        allAddonCategoryData.map((m, i) =>
          categoryOptions.push({
            label: m.title,
            value: m.id,
            key: i,
          })
        );
      }
      setAddonCategoryData(categoryOptions);
    }
    const membershipOptions = membershipGroupData;
    if (
      allMembershipGroupData !== undefined &&
      allMembershipGroupData.length > 0
    ) {
      allMembershipGroupData.map((m, i) =>
        membershipOptions.push({
          label: m,
          value: m,
          key: i,
        })
      );
    }
    setMembershipGroupData(membershipOptions);
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Service_By_Id}/${id}?groupId=${getGroupID()}&propertyId=${propertyId}`,
      })
        .then((res) => {
          if (isAccommodation === true) {
            let discountedPrice = 0;
            let discountedPriceEnd = 0;
            let body = {};
            body = Calculation(
              res.data.priceRangeStart,
              res.data.priceRangeEnd,
              res.data.taxIncluded,
              res.data.taxPercentage,
              res.data.discount,
              res.data.offerDiscount
            );
            if (body) {
              discountedPrice =
                body.discountedPrice === NaN ? 0 : body.discountedPrice;
              discountedPriceEnd =
                body.discountedPriceEnd === NaN ? 0 : body.discountedPriceEnd;
            }
            if (res.data.embedIframe !== null && res.data.embedIframe !== '') {
              setIsIframe(true);
            }
            if (
              res.data.embedIframeTop !== null &&
              res.data.embedIframeTop !== ''
            ) {
              setIsIframeTop(true);
            }
            setServiceData({
              ...res.data,
              discountedPrice: discountedPrice,
              discountedPriceEnd: discountedPriceEnd,
            });
          } else {
            setServiceData(res.data);
          }
          var selectedcategories = [];
          try {
            if (isAccommodation === true) {
              res.data.categoryId
                .filter((k) => k.languageCode === languageCode)
                .map((item, i) => {
                  if (item.id !== '') {
                    selectedcategories.push(
                      categoryOptions.filter((cat) => cat.value === item.id)[0]
                    );
                  }
                });
              // res.data.categories.map((item, i) => {
              //   selectedcategories.push(
              //     categoryOptions.filter((cat) => cat.value === item)[0]
              //   )
              // });
            } else {
              res.data.categories.map((item) =>
                selectedcategories.push(
                  categoriesData.filter((cat) => cat.value === item)[0]
                )
              );
            }
          } finally {
          }
          setselectedOptions(selectedcategories);
          setselectedcategories(selectedcategories);
          var selectedGuestLifeCycle = [];
          try {
            if (
              res.data.guestLifeCycle !== null &&
              res.data.guestLifeCycle.length > 0
            ) {
              selectedGuestLifeCycle = lifeCycle.map((elem) => {
                var exist = res.data.guestLifeCycle.filter(
                  (item) => item === elem.value
                );
                if (exist.length > 0) {
                  elem.checked = true;
                } else {
                  elem.checked = false;
                }
                return {
                  ...elem,
                };
              });
              setLifeCycle(selectedGuestLifeCycle);
            } else {
              selectedGuestLifeCycle = lifeCycle.map((elem) => {
                if (elem.checked) {
                  elem.checked = false;
                }
                return { ...elem };
              });
              setLifeCycle(selectedGuestLifeCycle);
            }
          } finally {
          }
          const membershipGroup = selectedGuestLifeCycle.filter(
            (i) => i.checked === true && i.value === 'Member Specific'
          );
          setIsMembershipGroup(membershipGroup.length > 0 ? true : false);
          var selectedMemmbershipgroup = [];
          if (
            res.data.membershipGroup != null &&
            res.data.membershipGroup.length > 0
          ) {
            res.data.membershipGroup.map((item, i) => {
              selectedMemmbershipgroup.push(
                membershipOptions.filter((cat) => cat.value === item)[0]
              );
            });
          }
          setSelectedMembershipGroup(selectedMemmbershipgroup);
          var selectedSuitability = [];
          try {
            if (res.data.suitability !== null) {
              res.data.suitability.map((item) =>
                selectedSuitability.push(
                  suitabilityData.filter((cat) => cat.value === item)[0]
                )
              );
            }
          } finally {
          }
          setSelectedSuitability(selectedSuitability);
        })
        .catch((err) => console.log('err', err));
    } else {
      var cycle = guestLifeCycleList.map((item) => {
        if (item.checked === true) {
          item.checked = false;
        }
        return { ...item };
      });
      setLifeCycle(cycle);
    }

    AxiosAPI({
      method: 'get',
      url: `${gAPI_GuestPassList}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${locale}&orderBy=${'Title'}&search=`,
    }).then((res) => {
      if (res.data.length > 0) {
        var list = res.data.sort((a, b) => a.displayOrder - b.displayOrder);
        console.log(list);
        setGuestLocation(list);
      }
    });
  }, [id]);

  const handleChangeMulti = (selectedOptions) => {
    if (selectedOptions.filter((i) => i.value === 'Add own tag').length === 0) {
      setselectedOptions(selectedOptions);
      const categoriesArr = selectedOptions.map((elem) => elem.value);
      setServiceData({
        ...serviceData,
        categories: categoriesArr,
      });
    } else {
      setAddTagModel(true);
      setIsCategoryTag(true);
    }
  };

  const handleChangeMultiAcc = (selectedOptions) => {
    if (selectedOptions.filter((i) => i.value === 'Add own tag').length === 0) {
      setselectedOptions(selectedOptions);
      var getExistingCat = serviceData.categoryId.filter(
        (k) => k.languageCode !== languageCode
      );
      const categoriesArr = [...getExistingCat];
      allAddonCategoryData.map((i) =>
        selectedOptions.map((elem) => {
          if (elem.value === i.id) {
            return categoriesArr.push({ id: i.id, languageCode: languageCode });
          }
        })
      );
      setServiceData({
        ...serviceData,
        categoryId: categoriesArr,
      });
    } else {
      setAddCategoryTagModel(true);
    }
  };

  const handleChangeMultiMembershipGroup = (selectedMembershipGroup) => {
    if (
      selectedMembershipGroup.filter((i) => i.value === 'Add own tag')
        .length === 0
    ) {
      setSelectedMembershipGroup(selectedMembershipGroup);
      const membershipGroupArr = selectedMembershipGroup.map(
        (elem) => elem.value
      );
      setServiceData({
        ...serviceData,
        membershipGroup: membershipGroupArr,
      });
    } else {
      setAddTagModel(true);
      setIsCategoryTag(false);
    }
  };
  const handleChangeMultiSuitability = (selectedSuitability) => {
    setSelectedSuitability(selectedSuitability);
    const suitabilityArr = selectedSuitability.map((elem) => elem.value);
    setServiceData({
      ...serviceData,
      suitability: suitabilityArr,
    });
  };
  const handleLifeCycleChange = (e) => {
    const values = lifeCycle.map((elem) => {
      if (elem.value === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setLifeCycle(values);
    const lifecycleArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.value);
    setIsMembershipGroup(lifecycleArr.includes('Member Specific'));
    setServiceData({
      ...serviceData,
      guestLifeCycle: lifecycleArr,
    });
  };
  const handleChangeVoucher = (e) => {
    var voucher = vouchers
      .filter((item) => item.id === e.target.value)
      .map((i) => i.name);
    let voucherName = '';
    if (voucher.length > 0) {
      voucherName = voucher[0];
    }
    setServiceData({
      ...serviceData,
      voucherId: e.target.value,
      voucherName: voucherName,
    });
  };
  const getFormName = (statement) => {
    if (statement !== undefined && statement.length > 0) {
      const index = statement.findIndex((m) => m.languageCode === languageCode);
      if (index === -1) {
        const englishIndex = statement.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statement[englishIndex].id;
        }
      } else {
        return statement[index].id;
      }
    } else {
      return '';
    }
  };
  const handleChangeForm = (e) => {
    if (serviceData.forms.length > 0) {
      const index = serviceData.forms.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const newStatement = {
          id: e.target.value,
          languageCode: languageCode,
        };
        setServiceData({
          ...serviceData,
          forms: [...serviceData.forms, newStatement],
        });
      } else {
        let newArr = [...serviceData.forms];
        newArr[index].id = e.target.value;
        setServiceData({
          ...serviceData,
          forms: newArr,
        });
      }
    } else {
      const newStatement = {
        id: e.target.value,
        languageCode: languageCode,
      };
      setServiceData({
        ...serviceData,
        forms: [...serviceData.forms, newStatement],
      });
    }
  };

  const handleChangeConFlow = (e) => {
    let conFlowName = '';
    var con = conversationFlowList.filter((item) => item.id === e.target.value);
    if (con.length > 0) {
      conFlowName = con[0].name;
    }
    if (serviceData.conversationFlow.length > 0) {
      const index = serviceData.conversationFlow.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const newStatement = {
          id: e.target.value,
          name: conFlowName,
          languageCode: languageCode,
        };
        setServiceData({
          ...serviceData,
          conversationFlow: [...serviceData.conversationFlow, newStatement],
        });
      } else {
        let newArr = [...serviceData.conversationFlow];
        newArr[index].id = e.target.value;
        newArr[index].name = conFlowName;
        setServiceData({
          ...serviceData,
          conversationFlow: newArr,
        });
      }
    } else {
      const newStatement = {
        id: e.target.value,
        name: conFlowName,
        languageCode: languageCode,
      };
      setServiceData({
        ...serviceData,
        conversationFlow: [...serviceData.conversationFlow, newStatement],
      });
    }
  };
  const handleChangeEventsCalendar = (e) => {
    let formId = e.target.value;
    let formName = '';
    var events = eventsData.filter((item) => item.id === e.target.value);
    if (events.length > 0) {
      formName = events[0].title;
    }
    setServiceData({
      ...serviceData,
      formId: formId,
      formName: formName,
    });
  };
  const handleChange = (e) => {
    let taxAmount = serviceData.taxAmount === 0 ? 0 : serviceData.taxAmount;
    let discountedPrice =
      serviceData.discountedPrice === 0 ? 0 : serviceData.discountedPrice;
    let discountedPriceEnd =
      serviceData.discountedPriceEnd === 0 ? 0 : serviceData.discountedPriceEnd;
    if (isAccommodation === true || isServiceOrder === true) {
      let body = {};
      if (e.target.name === 'priceRangeStart') {
        body = Calculation(
          e.target.value,
          serviceData.priceRangeEnd !== 0 ? serviceData.priceRangeEnd : 0,
          serviceData.taxIncluded !== 0 ? serviceData.taxIncluded : 0,
          serviceData.taxPercentage !== 0 ? serviceData.taxPercentage : 0,
          serviceData.discount !== 0 ? serviceData.discount : 0,
          serviceData.offerDiscount
        );
      }
      if (e.target.name === 'priceRangeEnd') {
        body = Calculation(
          serviceData.priceRangeStart !== 0 ? serviceData.priceRangeStart : 0,
          e.target.value,
          serviceData.taxIncluded !== 0 ? serviceData.taxIncluded : 0,
          serviceData.taxPercentage !== 0 ? serviceData.taxPercentage : 0,
          serviceData.discount !== 0 ? serviceData.discount : 0,
          serviceData.offerDiscount
        );
      }
      if (e.target.name === 'taxIncluded') {
        body = Calculation(
          serviceData.priceRangeStart !== 0 ? serviceData.priceRangeStart : 0,
          serviceData.priceRangeEnd !== 0 ? serviceData.priceRangeEnd : 0,
          e.target.value,
          serviceData.taxPercentage !== 0 ? serviceData.taxPercentage : 0,
          serviceData.discount !== 0 ? serviceData.discount : 0,
          serviceData.offerDiscount
        );
      }
      if (e.target.name === 'taxPercentage') {
        body = Calculation(
          serviceData.priceRangeStart !== 0 ? serviceData.priceRangeStart : 0,
          serviceData.priceRangeEnd !== 0 ? serviceData.priceRangeEnd : 0,
          serviceData.taxIncluded !== 0 ? serviceData.taxIncluded : 0,
          e.target.value,
          serviceData.discount !== 0 ? serviceData.discount : 0,
          serviceData.offerDiscount
        );
      }
      if (e.target.name === 'discount') {
        body = Calculation(
          serviceData.priceRangeStart !== 0 ? serviceData.priceRangeStart : 0,
          serviceData.priceRangeEnd !== 0 ? serviceData.priceRangeEnd : 0,
          serviceData.taxIncluded !== 0 ? serviceData.taxIncluded : 0,
          serviceData.taxPercentage !== 0 ? serviceData.taxPercentage : 0,
          e.target.value,
          serviceData.offerDiscount
        );
      }
      if (
        e.target.name === 'priceRangeStart' ||
        e.target.name === 'priceRangeEnd' ||
        e.target.name === 'taxIncluded' ||
        e.target.name === 'taxPercentage' ||
        e.target.name === 'discount'
      ) {
        if (body) {
          taxAmount = body.taxAmount === NaN ? 0 : body.taxAmount;
          discountedPrice =
            body.discountedPrice === NaN ? 0 : body.discountedPrice;
          discountedPriceEnd =
            body.discountedPriceEnd === NaN ? 0 : body.discountedPriceEnd;
        }
      }
    }
    // else if (isServiceOrder === true) {
    //   if (e.target.name === "priceRangeStart") {
    //     discountedPrice = parseFloat(e.target.value);

    //   }
    //   if (e.target.name === "taxIncluded") {
    //     let mainPrice = parseFloat(serviceData.priceRangeStart);
    //     if (e.target.value === true) {
    //       let amount = ((parseFloat(serviceData.taxPercentage) + 100) / 100).toFixed(2);
    //       let tax = parseFloat(mainPrice / amount).toFixed(2);
    //       taxAmount = parseFloat(mainPrice - tax).toFixed(2);
    //     }
    //   }
    // }
    if (e.target.name === 'bookingMethod') {
      if (e.target.value === 'aiva') {
        serviceData.externalUrl = [
          {
            statement: '',
            languageCode: languageCode,
          },
        ];
        serviceData.promoCode = [
          {
            statement: '',
            languageCode: languageCode,
          },
        ];
        serviceData.instructions = [
          {
            statement: '',
            languageCode: languageCode,
          },
        ];
      } else if (
        e.target.value === 'ExternalURL' ||
        e.target.value === 'ExternalURLNewWindow'
      ) {
        serviceData.promoCode = [
          {
            statement: '',
            languageCode: 'en',
          },
        ];
      }
    }
    // console.log(serviceData);
    setServiceData({
      ...serviceData,
      taxAmount: taxAmount,
      discountedPrice: discountedPrice,
      discountedPriceEnd: discountedPriceEnd,
      [e.target.name]: e.target.value,
    });
  };
  const Calculation = (
    startPrice,
    endPrice,
    taxIncluded,
    taxPercentage,
    discount,
    offerDiscount
  ) => {
    let mainPrice = 0;
    let discountPrice = parseFloat(startPrice);
    let discountPrice2 = parseFloat(endPrice);
    let taxxAmount = 0;
    discount = discount === NaN ? 0 : discount;
    mainPrice = (parseFloat(startPrice) + parseFloat(endPrice)) / 2;
    let price =
      parseFloat(mainPrice) + parseFloat(taxIncluded === 'true' ? 0 : 0);
    if (offerDiscount && parseFloat(discount) !== 0) {
      let price1 = parseFloat(startPrice);
      let price2 = parseFloat(endPrice);
      let discountAmt = Math.round((price1 * parseFloat(discount)) / 100);
      discountPrice = Math.round(price1 - discountAmt);
      let discountAmt2 = Math.round((price2 * parseFloat(discount)) / 100);
      discountPrice2 = Math.round(price2 - discountAmt2);
    }
    if (taxIncluded === true) {
      let amount = ((parseFloat(taxPercentage) + 100) / 100).toFixed(2);
      let tax = parseFloat(mainPrice / amount).toFixed(2);
      taxxAmount = parseFloat(mainPrice - tax).toFixed(2);
    } else {
      taxxAmount = (
        (parseFloat(mainPrice) * parseFloat(taxPercentage)) /
        100
      ).toFixed(2);
    }
    let amo = {
      taxAmount: taxxAmount,
      discountedPrice: discountPrice,
      discountedPriceEnd: discountPrice2,
    };
    return amo;
  };
  // const getFiles = (files) => {
  //     setServiceData({
  //         ...serviceData,
  //         imageData: files.base64.split(",")[1],
  //     });
  // }
  const handleCheckedDiscount = (e) => {
    let discount = e.target.checked ? serviceData.discount : 0;
    let discountedPrice = e.target.checked
      ? serviceData.discount === 0
        ? serviceData.priceRangeStart
        : serviceData.discountedPrice
      : serviceData.priceRangeStart;
    let discountedPriceEnd = e.target.checked
      ? serviceData.discount === 0
        ? serviceData.priceRangeEnd
        : serviceData.discountedPriceEnd
      : serviceData.priceRangeEnd;
    if (isAccommodation === true || isServiceOrder === true) {
      let body = {};
      body = Calculation(
        serviceData.priceRangeStart,
        serviceData.priceRangeEnd,
        serviceData.taxIncluded,
        serviceData.taxPercentage,
        serviceData.discount,
        e.target.checked
      );
    }
    setServiceData({
      ...serviceData,
      discount: discount,
      discountedPrice: discountedPrice,
      discountedPriceEnd: discountedPriceEnd,
      offerDiscount: e.target.checked,
    });
  };
  const handleCheckedGlobal = (e) => {
    if (e.target.checked === true) {
      if (serviceData.formId !== '' && serviceData.formId !== '0') {
        var checkform = formsData.filter((i) => i.id === serviceData.formId);
        if (checkform.length > 0) {
          var isformGlobal = checkform[0].isGlobal;
          if (isformGlobal === true) {
            setServiceData({
              ...serviceData,
              isGlobal: e.target.checked,
            });
          } else {
            setErrorModel({
              isVisible: true,
              msg: 'This item has a Form linked to it. Mark the Form as global before proceeding with the item.',
            });
          }
        }
      } else {
        setServiceData({
          ...serviceData,
          isGlobal: e.target.checked,
        });
      }
    } else {
      setServiceData({
        ...serviceData,
        isGlobal: e.target.checked,
      });
    }
  };
  const handleCheckedHighlightItem = (e) => {
    setServiceData({
      ...serviceData,
      highlightItem: e.target.checked,
    });
  };
  //console.log(serviceData);
  const handleChangeArr = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setServiceData({
      ...serviceData,
      [key]: [
        {
          statement: value,
          languageCode: languageCode,
        },
      ],
    });
  };
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  const toggleTypeToolTip = () => {
    setTypeToolTip(!typeToolTip);
  };
  const togglePriceToolTip = () => {
    setpriceToolTip(!priceToolTip);
  };
  const toggleCategoryToolTip = () => {
    setCategoryToolTip(!categoryToolTip);
  };
  const toggleGlobelToolTip = () => {
    setGlobelToolTip(!globelToolTip);
  };

  const handleDelete = () => {
    var selectedresponsecodes = [];
    if (!isDoctor && !isAccommodation) {
      try {
        serviceData.categories.map((item) => {
          let categoryMapp = categoryBotResponseCodeMapping.filter(
            (code) => code.category === item
          );
          if (categoryMapp.length > 0) {
            selectedresponsecodes.push(categoryMapp[0].responseCode);
          }
        });
      } finally {
      }
    }
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Service}/${id}`,
      data: {
        propertyId: propertyId,
        deleter: 'dashboard',
        botResponseCode: selectedresponsecodes,
      },
    })
      .then((res) => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This service will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const IconGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={iconGalleryVisible}
                toggle={toggleIconGallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleIconGallery}>
                  Select Svg Icon or Upload New Svg
                </ModalHeader>
                <ModalBody>
                  <IconGallery
                    propertyId={propertyId}
                    selectedSvg={selectedIcon}
                    togglegallery={toggleIconGallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleSubmit = () => {
    var isValid = false;
    if (serviceData.bookingMethod === 'SubmitForm') {
      const index = serviceData.forms.filter(
        (m) => m.languageCode === languageCode
      );
      if (index.length > 0 && index[0].id !== '') {
        isValid = true;
      }
    } else {
      isValid = true;
    }

    if (isValid) {
      var selectedresponsecodes = [];
      var selectedLuis = [];

      if (!isDoctor && !isAccommodation) {
        try {
          serviceData.categories.map((item) => {
            let categoryMapp = categoryBotResponseCodeMapping.filter(
              (code) => code.category === item
            );
            if (categoryMapp.length > 0) {
              selectedresponsecodes.push(categoryMapp[0].responseCode);
            }
          });
        } finally {
        }
      }
      if (isDoctor) {
        console.log('selectedcategories', serviceData.categories);
        try {
          serviceData.categories.map((item) =>
            selectedLuis.push({
              luisIntent: drBotResponseCodeMapping.filter(
                (code) => code.category === item
              )[0].intent,
              luisEntityKey: drBotResponseCodeMapping.filter(
                (code) => code.category === item
              )[0].entity_key,
              luisEntityValue: drBotResponseCodeMapping.filter(
                (code) => code.category === item
              )[0].entity_value,
            })
          );
        } finally {
        }
      }
      // if (isAccommodation) {
      //   //console.log('selectedcategories', serviceData.categories);
      //   try {
      //     serviceData.categories.map((item) =>
      //       selectedLuis.push({
      //         luisIntent: accoBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].intent,
      //         luisEntityKey: accoBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].entity_key,
      //         luisEntityValue: accoBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].entity_value,
      //       })
      //     );
      //   } finally {
      //   }
      // }
      console.log(selectedLuis);
      if (id !== undefined) {
        var deletedcategories = [];
        var deletedresponsecodes = [];
        if (!isDoctor && !isAccommodation) {
          try {
            selectedcategories.map((item) =>
              serviceData.categories.filter((code) => code === item.value)
                .length === 0
                ? deletedcategories.push(item.value)
                : null
            );
          } finally {
          }
          try {
            deletedcategories.map((item) => {
              let categoryMapp = categoryBotResponseCodeMapping.filter(
                (code) => code.category === item
              );
              if (categoryMapp.length > 0) {
                deletedresponsecodes.push(categoryMapp[0].responseCode);
              }
            });
          } finally {
          }
        }
        const formmatedData = {
          ...serviceData,
          CurrentPropertyId: propertyId,
          Updater: 'admin',
          botResponseCode: selectedresponsecodes,
          deleteBotResponseCode: deletedresponsecodes,
          categoryLuisSettings: selectedLuis,
        };

        console.log(formmatedData);

        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Service}/${id}`,
          data: formmatedData,
        })
          .then((res) => {
            if (
              res.data.HttpStatusCode !== undefined &&
              res.data.HttpStatusCode === 400 &&
              res.data.Messages !== undefined &&
              res.data.Messages !== null &&
              res.data.Messages.length > 0
            ) {
              setMsg(res.data.Messages);
              setOpen(true);
            } else {
              toggleModal();
              setTimeout(() => {
                LoadData(languageCode);
              }, 1000);
            }
            //console.log(res.data);
          })
          .catch((err) => {
            console.log('err', err);
          });
      } else {
        const formmatedData = {
          ...serviceData,
          botResponseCode: selectedresponsecodes,
          categoryLuisSettings: selectedLuis,
        };
        AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_Services}`,
          data: formmatedData,
        })
          .then((res) => {
            if (
              res.data.HttpStatusCode !== undefined &&
              res.data.HttpStatusCode === 400 &&
              res.data.Messages !== undefined &&
              res.data.Messages !== null &&
              res.data.Messages.length > 0
            ) {
              setMsg(res.data.Messages);
              setOpen(true);
            } else {
              console.log(res.data);
              toggleModal();
              setTimeout(() => {
                LoadData(languageCode);
              }, 1000);
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    } else {
      setErrorModel({
        isVisible: true,
        msg: "You didn't select form! please select a form.",
      });
    }
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleChangeHighlightsArr = (source, e) => {
    if (source === 'user') {
      if (serviceData.displayText.length > 0) {
        const index = serviceData.displayText.findIndex(
          (m) => m.languageCode === languageCode
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: languageCode,
          };
          setServiceData({
            ...serviceData,
            displayText: [...serviceData.displayText, newStatement],
          });
        } else {
          let newArr = [...serviceData.displayText];
          newArr[index].statement = e;
          setServiceData({
            ...serviceData,
            displayText: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: languageCode,
        };
        setServiceData({
          ...serviceData,
          displayText: [...serviceData.displayText, newStatement],
        });
      }
    }
  };
  const handleChangeConditionsArr = (source, e) => {
    if (source === 'user') {
      if (serviceData.conditions.length > 0) {
        const index = serviceData.conditions.findIndex(
          (m) => m.languageCode === languageCode
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: languageCode,
          };
          setServiceData({
            ...serviceData,
            conditions: [...serviceData.conditions, newStatement],
          });
        } else {
          let newArr = [...serviceData.conditions];
          newArr[index].statement = e;
          setServiceData({
            ...serviceData,
            conditions: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: languageCode,
        };
        setServiceData({
          ...serviceData,
          conditions: [...serviceData.conditions, newStatement],
        });
      }
    }
  };
  const handleChangeTitle = (e) => {
    if (serviceData.title.length > 0) {
      const index = serviceData.title.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: languageCode,
        };
        setServiceData({
          ...serviceData,
          title: [...serviceData.title, newStatement],
        });
      } else {
        let newArr = [...serviceData.title];
        newArr[index].statement = e.target.value;
        setServiceData({
          ...serviceData,
          title: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: languageCode,
      };
      setServiceData({
        ...serviceData,
        title: [...serviceData.title, newStatement],
      });
    }
  };
  const handleChangeInstruction = (e) => {
    if (serviceData.instructions.length > 0) {
      const index = serviceData.instructions.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: languageCode,
        };
        setServiceData({
          ...serviceData,
          instructions: [...serviceData.instructions, newStatement],
        });
      } else {
        let newArr = [...serviceData.instructions];
        newArr[index].statement = e.target.value;
        setServiceData({
          ...serviceData,
          instructions: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: languageCode,
      };
      setServiceData({
        ...serviceData,
        instructions: [...serviceData.instructions, newStatement],
      });
    }
  };
  const handleChangeSubmitButtonText = (e) => {
    if (serviceData.submitButtonText.length > 0) {
      const index = serviceData.submitButtonText.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: languageCode,
        };
        setServiceData({
          ...serviceData,
          submitButtonText: [...serviceData.submitButtonText, newStatement],
        });
      } else {
        let newArr = [...serviceData.submitButtonText];
        newArr[index].statement = e.target.value;
        setServiceData({ ...serviceData, submitButtonText: newArr });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: languageCode,
      };
      setServiceData({
        ...serviceData,
        submitButtonText: [...serviceData.submitButtonText, newStatement],
      });
    }
  };
  const handleSignUpAiva = () => {
    window.open('https://app.getaiva.com/user/vouchersignup');
  };
  const handleLearnMoreAiva = () => {
    window.open('https://getaiva.com/');
  };
  const handleCustomisationsTag = (val) => {
    if (isCategoryTag === true) {
      let keyValue = addonCategoryData.length;
      let tag = [...addonCategoryData];
      tag.push({ label: val, value: val, key: keyValue });
      let tag1 = [...selectedOptions];
      tag1.push({ label: val, value: val, key: keyValue });
      setselectedOptions(tag1);
      setAddonCategoryData(tag);
      setselectedcategories(tag1);
      setAddTagModel(!addTagModel);
      setOwnTag('');
      const tagsArr = tag1.map((elem) => elem.value);
      setServiceData({
        ...serviceData,
        categories: tagsArr,
      });
    } else {
      let keyValue = membershipGroupData.length;
      let tag = [...membershipGroupData];
      tag.push({ label: val, value: val, key: keyValue });
      let tag1 = [...selectedMembershipGroup];
      tag1.push({ label: val, value: val, key: keyValue });
      setSelectedMembershipGroup(tag1);
      setMembershipGroupData(tag);
      setAddTagModel(!addTagModel);
      setOwnTag('');
      const tagsArr = tag1.map((elem) => elem.value);
      setServiceData({
        ...serviceData,
        membershipGroup: tagsArr,
      });
    }
  };
  const handleEditCategory = () => {
    setIsEditCategory(true);
    setAddCategoryTagModel(true);
  };
  const handleAppearance = (data) => {
    setServiceData({ ...serviceData, appearance: data });
  };
  const handleOwnCategoryTag = (data) => {
    let keyValue = addonCategoryData.length;
    let tag = [...addonCategoryData];
    tag.push({ label: data.title, value: data.id, key: keyValue });
    let tag1 = [...selectedOptions];
    tag1.push({ label: data.title, value: data.id, key: keyValue });
    setselectedOptions(tag1);
    setAddonCategoryData(tag);
    setselectedcategories(tag1);
    const categoriesArr = [...serviceData.categoryId];
    categoriesArr.push({ id: data.id, languageCode: data.languageCode });
    setServiceData({
      ...serviceData,
      // categoryLayout: [data],
      categoryId: categoriesArr,
    });
  };
  const handleUpdateOwnCategoryTag = (data) => {
    var newAddonlist = addonCategoryData.filter((i) => i.value !== data.id);
    let keyValue = newAddonlist.length;
    let tag = [...newAddonlist];
    tag.push({ label: data.title, value: data.id, key: keyValue });
    var newselectedoption = selectedOptions.filter((i) => i.value !== data.id);
    let tag1 = [...newselectedoption];
    tag1.push({ label: data.title, value: data.id, key: keyValue });
    setselectedOptions(tag1);
    setAddonCategoryData(tag);
    setselectedcategories(tag1);
    var filterexisting = serviceData.categoryId.filter((i) => i.id !== data.id);
    const categoriesArr = [...filterexisting];
    categoriesArr.push({ id: data.id, languageCode: data.languageCode });
    // allAddonCategoryData.map((i) =>  tag1.map((elem) =>{
    //   if (elem.value === i.id) {
    //     return categoriesArr.push(i.id);
    //   }
    // }));
    setServiceData({
      ...serviceData,
      //categoryLayout: categoriesArr,
      categoryId: categoriesArr,
    });
  };
  const { getRootProps, getInputProps } = useDropzone({
    //accept: 'image/*',
    // accept: 'image/*,font/*',
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        if (file.name.includes('mp4') || file.name.includes('gif')) {
          fileObj = [
            {
              img: Object.assign(file, {
                preview: URL.createObjectURL(file),
              }),
              tags: [],
              caption: '',
            },
          ];
        } else {
          handleFileToggle();
          setFileErrorMsg(
            'Invalid document, please upload .txt or .docx document.'
          );
        }
      });
      setFiles(fileObj);
    },
  });

  const UploadMedia = () => {
    return (
      <Modal isOpen={fileUpload} size="lg" toggle={handleFileUploadToggle}>
        <ModalHeader toggle={handleFileUploadToggle}>Video</ModalHeader>
        <ModalBody>
          <Row>
            <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
              <Row className="mb-4">
                <section className="container">
                  <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <div class="dz-default dz-message">
                      <span>
                        Drop files here to upload, or click to select files.
                        Recommended upload limit of 10mb per file. Supported
                        formats: JPEG, PNG, GIF, WEBP, SVG.
                      </span>
                      <p className="font-weight-medium mb-0 ">
                        <i className="demo-icon simple-icon-cursor-move"></i>
                      </p>
                    </div>
                  </div>
                  <div
                    className="filepicker dropzone-gallery dz-clickable dz-started"
                    style={{ minHeight: '100px', border: '0px' }}
                  >
                    {files.map((file, index) => (
                      <div
                        className="dz-preview dz-file-preview mb-3"
                        key={index}
                        style={{ height: '100px' }}
                      >
                        <div className="row">
                          <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                            <div>
                              {' '}
                              <span data-dz-name>{file.img.name}</span>{' '}
                            </div>
                            <div
                              className="text-primary text-extra-small"
                              data-dz-size
                            >
                              {file.img.size}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              </Row>
              <div
                className="d-flex text-center ml-0 font-weight-bold mt-1 mb-2"
                style={{ justifyContent: 'center' }}
              >
                <CustomInput
                  type="checkbox"
                  id="agree"
                  value={isAgree}
                  checked={isAgree}
                  onChange={(e) => {
                    setAgree(!isAgree);
                  }}
                >
                  <span className="mt-1" style={{ verticalAlign: 'sub' }}>
                    I have copyright or permissions to use this document.
                  </span>
                </CustomInput>
              </div>
              <div
                className="d-flex text-center ml-0 font-weight-bold mt-1 mb-2"
                style={{ justifyContent: 'center' }}
              >
                <CustomInput
                  type="checkbox"
                  id="agree"
                  value={isCheck}
                  checked={isCheck}
                  onChange={(e) => {
                    setIsCheck(!isCheck);
                  }}
                >
                  <span className="mt-1" style={{ verticalAlign: 'sub' }}>
                    This document does not contain any personally identifiable
                    information.
                  </span>
                </CustomInput>
              </div>
              <div className="mt-2 d-flex" style={{ justifyContent: 'center' }}>
                <Button
                  color="primary"
                  onClick={handleMediaSubmit}
                  className={`btn-multiple-state text-white ${classnames({
                    'show-spinner': ApiState === 'processing',
                    'show-success': ApiState === 'success',
                    'show-fail': ApiState === 'fail',
                  })}`}
                >
                  <span className="spinner d-inline-block">
                    <span className="bounce1" />
                    <span className="bounce2" />
                    <span className="bounce3" />
                  </span>
                  <span className="icon success">
                    <i className="simple-icon-check" />
                  </span>
                  <span className="icon fail">
                    <i className="simple-icon-exclamation" />
                  </span>
                  <span className="label">Save</span>
                </Button>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
    );
  };

  const handleMediaSubmit = () => {
    if (isAgree && isCheck) {
      const data = new FormData();
      files.forEach((file) => {
        data.append('files', file.img);
        data.append('tags', file.tags);
        data.append('captions', file.caption);
      });
      data.append('folder', 'bmbgallery');
      data.append('groupId', getGroupID());
      data.append('creator', 'dashboard');

      // setApiState("processing")
      AxiosAPI({
        method: 'post',
        url: `${API_Media_Upload}`,
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(
        (res) => {
          console.log(res, res.data);
          setServiceData({ ...serviceData, media: res.data.status });
          setFiles([]);
          handleFileUploadToggle();
        },
        (error) => {
          //  setApiState('fail')
          console.log('eee.data', error.data);
        }
      );
    }
  };
  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggleModal}
        wrapClassName="modal-right"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>
          {formLabel}{' '}
          {isServiceOrder === true ? (
            <IntlMessages id="menu.guestservice"></IntlMessages>
          ) : (
            <IntlMessages id="virtual-front.guest-service-add-on-upsells" />
          )}
        </ModalHeader>
        {serviceData != undefined && (
          <ModalBody>
            {/* <pre>{JSON.stringify(serviceData, null, 2)}</pre> */}
            <Label className="mt-3">
              Title <i className="demo-icon simple-icon-info" id="titletip"></i>
            </Label>

            <Tooltip
              placement="right"
              isOpen={titleToolTip}
              target="titletip"
              toggle={toggleTitleToolTip}
            >
              A short title which will appear when users ask about the service
            </Tooltip>
            <Input
              type="text"
              onChange={handleChangeTitle}
              value={getLocalStatement(serviceData.title)}
              name="title"
              maxLength={50}
              placeholder={titlePlaceholderText()}
            />
            <Label className="mt-3">
              Type <i className="demo-icon simple-icon-info" id="typetip"></i>
            </Label>
            {typeTooltipText()}
            <Input
              type="select"
              name="type"
              value={serviceData.type}
              onChange={handleChange}
            >
              <option value="0">Select</option>
              {qbot === false ? (
                <Fragment>
                  {isAccommodation === true ? (
                    <Fragment>
                      <option value="InformationOnly">Information Only</option>
                      <option value="TitleAction">Title & Action</option>
                      <option value="InformationAction">
                        Information & Action
                      </option>
                      <option value="InformationPrice">
                        Information, Pricing & Action
                      </option>
                      <option value="Media">Media</option>
                      {/* {id !== undefined ?
                        <Fragment>
                          <option value="ServiceActivity">
                            Service or Activity
                          </option>
                          <option value="Amentity">Amentity</option>
                          <option value="aivaVoucher">aiva Voucher</option>
                          <option value="Retail">Retail</option>
                          <option value="Product">Product</option>
                          <option value="InformationOnly">Information Only</option>
                          <option value="InformationAction">Information & Action</option>
                          <option value="InformationPrice">Information, Pricing & Action</option>
                          <option value="RoomService">Room Service</option>
                          <option value="Housekeeping">Housekeeping</option>
                        </Fragment> :
                        <Fragment>
                          <option value="InformationOnly">Information Only</option>
                          <option value="InformationAction">Information & Action</option>
                          <option value="InformationPrice">Information, Pricing & Action</option>
                        </Fragment>
                      } */}
                    </Fragment>
                  ) : (
                    <Fragment>
                      <option value="Package">Package</option>
                      <option value="Offer">Offer</option>
                      <option value="Service">Service</option>
                    </Fragment>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <option value="RoomService">Room Service</option>
                  <option value="Housekeeping">Housekeeping</option>
                </Fragment>
              )}
            </Input>
            {serviceData.type !== 'Media' && (
              <div className="row">
                <div className="col-12">
                  {isIframeTop ? (
                    <Fragment>
                      <Label className="mt-3">Embed Iframe</Label>
                      <Input
                        type="textarea"
                        onChange={handleChange}
                        value={serviceData.embedIframeTop}
                        name="embedIframeTop"
                        placeholder={'Enter Iframe'}
                      />
                    </Fragment>
                  ) : (
                    serviceData.type !== 'TitleAction' && (
                      <Button
                        color="primary"
                        className="mt-3"
                        size="xs"
                        outline
                        onClick={() => setIsIframeTop(true)}
                      >
                        +Embed Iframe
                      </Button>
                    )
                  )}
                </div>
              </div>
            )}
            {/* {isAivaProperty === true && serviceData.type === 'aivaVoucher' ? (
              <Fragment>
                <Label className="mt-3">Select Voucher(s)</Label>
                <Input
                  type="select"
                  name="vouchers"
                  value={serviceData.voucherId}
                  onChange={handleChangeVoucher}
                >
                  <option value={''}>Select</option>
                  {vouchers.length > 0 &&
                    vouchers.map(
                      (item) =>
                        item.name !== '' && (
                          <option value={item.id}>{item.name}</option>
                        )
                    )}
                </Input>
              </Fragment>
            ) : (
              serviceData.type === 'aivaVoucher' && (
                <div className="text-center p-2 mt-2">
                  <p style={{ fontSize: '15px' }}>
                    <b>aiva</b> is an automated, direct sell voucher system
                    allowing you to offer fully branded vouchers on your
                    website.{' '}
                  </p>
                  <p className="mt-3" style={{ fontSize: '15px' }}>
                    Currently, you do not have an account for <b>aiva</b>. It's
                    quick, inexpensive, simple and smart. Ten minutes is all it
                    takes to sign-up and upload your first voucher.
                  </p>
                  <div
                    className="d-flex"
                    style={{
                      flexDirection: 'column',
                      alignContent: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleLearnMoreAiva()}
                      size="xs"
                    >
                      Learn More <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleSignUpAiva()}
                      size="xs"
                    >
                      Sign Up <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                  </div>
                </div>
              )
            )}
            {serviceData.voucherId !== null &&
              serviceData.voucherId !== '' &&
              serviceData.voucherName !== null &&
              serviceData.voucherName !== '' &&
              serviceData.type === 'aivaVoucher' && (
                <div className="text-left p-2 mt-2">
                  <span>
                    <a
                      href={
                        `${process.env.REACT_APP_VOUCHERAIVA_URL}/vhp?id=` +
                        serviceData.voucherId
                      }
                      target="_blank"
                      style={{ textDecoration: 'underline', fontWeight: '600' }}
                    >
                      Click here
                    </a>{' '}
                    to view the voucher
                  </span>
                  <br />
                </div>
              )} */}
            {serviceData.type !== 'aivaVoucher' &&
              serviceData.type !== 'Media' &&
              serviceData.bookingMethod !== 'aiva' &&
              serviceData.type !== 'TitleAction' && (
                <Fragment>
                  <Label className="mt-3">Highlights</Label>
                  <ReactQuill
                    theme="snow"
                    value={getLocalStatement(serviceData.displayText)}
                    onChange={(content, delta, source) =>
                      handleChangeHighlightsArr(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="displayText"
                  />
                </Fragment>
              )}
            <div className="row">
              {serviceData.type !== 'Media' && (
                <div className="col-12">
                  {isIframe ? (
                    <Fragment>
                      <Label className="mt-3">Embed Iframe</Label>
                      <Input
                        type="textarea"
                        onChange={handleChange}
                        value={serviceData.embedIframe}
                        name="embedIframe"
                        placeholder={'Enter Iframe'}
                      />
                    </Fragment>
                  ) : (
                    serviceData.type !== 'TitleAction' && (
                      <Button
                        color="primary"
                        className="mt-3"
                        size="xs"
                        outline
                        onClick={() => setIsIframe(true)}
                      >
                        +Embed Iframe
                      </Button>
                    )
                  )}
                </div>
              )}
            </div>
            {serviceData.type !== 'Media' && (
              <div className="row">
                <div className="col-12">
                  <Label className="mt-3"></Label>
                  <CustomInput
                    type="checkbox"
                    id="highlightItem"
                    label="Highlight This Item"
                    checked={serviceData.highlightItem}
                    onChange={handleCheckedHighlightItem}
                  />
                </div>
              </div>
            )}
            {isAivaProperty === false &&
            serviceData.type === 'aivaVoucher' &&
            serviceData.bookingMethod === 'aiva' ? (
              ''
            ) : (
              <Fragment>
                <Label className="mt-3">Guest Lifecycle Applicability</Label>
                <div className="row">
                  {lifeCycle.map((item, index) => (
                    <div className="col-md-6" key={index}>
                      <CustomInput
                        type="checkbox"
                        id={'guestLifeCycle' + index}
                        value={item.value}
                        label={item.label}
                        checked={item.checked}
                        onChange={handleLifeCycleChange}
                      />
                    </div>
                  ))}
                </div>
                {isMembershipGroup && (
                  <Fragment>
                    <Label className="mt-3">Membership Group</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedMembershipGroup}
                      onChange={handleChangeMultiMembershipGroup}
                      options={membershipGroupData}
                    />
                  </Fragment>
                )}

                <Label className="mt-3">Suitability</Label>
                <Select
                  components={{ Input: CustomSelectInput }}
                  className="react-select"
                  classNamePrefix="react-select"
                  isMulti={true}
                  name="form-field-name"
                  value={selectedSuitability}
                  onChange={handleChangeMultiSuitability}
                  options={suitabilityData}
                />
                <Label className="mt-3">Status</Label>
                <Input
                  type="select"
                  name="status"
                  value={serviceData.status}
                  onChange={handleChange}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Draft">Draft</option>
                  <option value="Archieve">Archive</option>
                </Input>
                <Label className="mt-3">
                  Categories{' '}
                  {isDoctor && (
                    <i
                      className="demo-icon simple-icon-info"
                      id="categoryToolTip"
                    ></i>
                  )}
                </Label>
                {categoryTooltipText()}
                {/* {qbot === false ? (
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                isMulti={true}
                name="form-field-name"
                value={selectedOptions}
                onChange={handleChangeMulti}
                options={salonCategoriesData}
              />
            ) : (
              <Select
                components={{ Input: CustomSelectInput }}
                className="react-select"
                classNamePrefix="react-select"
                isMulti={true}
                name="form-field-name"
                value={selectedOptions}
                onChange={handleChangeMulti}
                options={GuestServicesCategoriesData}
              />
            )} */}
                {generatorCategorySelect()}
                {id !== undefined && isAccommodation === true && (
                  <div className="text-right mt-1">
                    <Button
                      color="primary"
                      size="xs"
                      outline
                      onClick={() => handleEditCategory()}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                      {''}
                      <IntlMessages id="survey.edit" />{' '}
                      <IntlMessages id="survey.category" />
                    </Button>
                  </div>
                )}
              </Fragment>
            )}
            {serviceData.type !== 'aivaVoucher' &&
              serviceData.type !== 'Media' &&
              serviceData.bookingMethod !== 'aiva' && (
                <Fragment>
                  {qbot === false ? (
                    serviceData.type !== 'Retail' &&
                    serviceData.type !== 'InformationOnly' &&
                    serviceData.type !== 'InformationAction' &&
                    serviceData.type !== 'TitleAction' && (
                      <Fragment>
                        <Label className="mt-3">
                          Price Range{' '}
                          <i
                            className="demo-icon simple-icon-info"
                            id="pricetip"
                          ></i>{' '}
                        </Label>
                        {priceChangeTooltipText()}
                      </Fragment>
                    )
                  ) : isServiceOrder === true ? (
                    <Fragment>
                      <Label className="mt-3">
                        Price Range{' '}
                        <i
                          className="demo-icon simple-icon-info"
                          id="pricetip"
                        ></i>{' '}
                      </Label>
                      {priceChangeTooltipText()}
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Label className="mt-3">
                        Price{' '}
                        <i
                          className="demo-icon simple-icon-info"
                          id="pricetip"
                        ></i>{' '}
                      </Label>
                      <Tooltip
                        placement="right"
                        isOpen={priceToolTip}
                        target="pricetip"
                        toggle={togglePriceToolTip}
                      >
                        You can chose your digital assistant to give customer a
                        single price.
                      </Tooltip>
                    </Fragment>
                  )}

                  {qbot === false ? (
                    <div className="row">
                      {serviceData.type !== 'Retail' &&
                        serviceData.type !== 'InformationOnly' &&
                        serviceData.type !== 'InformationAction' &&
                        serviceData.type !== 'TitleAction' && (
                          <Fragment>
                            <div className="col-5">
                              <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                  $
                                </InputGroupAddon>
                                <Input
                                  required
                                  name="priceRangeStart"
                                  type="number"
                                  min="0"
                                  value={serviceData.priceRangeStart}
                                  onChange={handleChange}
                                />
                              </InputGroup>
                            </div>
                            <div className="col-2 mt-3">to</div>
                            <div className="col-5">
                              <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                  $
                                </InputGroupAddon>
                                <Input
                                  required
                                  name="priceRangeEnd"
                                  type="number"
                                  min="0"
                                  value={serviceData.priceRangeEnd}
                                  onChange={handleChange}
                                />
                              </InputGroup>
                            </div>
                          </Fragment>
                        )}
                    </div>
                  ) : isServiceOrder === true ? (
                    <div className="row">
                      <div className="col-5">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            $
                          </InputGroupAddon>
                          <Input
                            required
                            name="priceRangeStart"
                            type="number"
                            min="0"
                            value={serviceData.priceRangeStart}
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </div>
                      <div className="col-2 mt-3">to</div>
                      <div className="col-5">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            $
                          </InputGroupAddon>
                          <Input
                            required
                            name="priceRangeEnd"
                            type="number"
                            min="0"
                            value={serviceData.priceRangeEnd}
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </div>
                    </div>
                  ) : (
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                      <Input
                        required
                        name="priceRangeStart"
                        type="number"
                        min="0"
                        value={serviceData.priceRangeStart}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  )}
                  {isAccommodation === true &&
                  serviceData.type !== 'Retail' &&
                  serviceData.type !== 'InformationOnly' &&
                  serviceData.type !== 'InformationAction' &&
                  serviceData.type !== 'TitleAction' ? (
                    <Fragment>
                      <div className="row">
                        <div className="col-12">
                          <Label className="mt-3"></Label>
                          <CustomInput
                            type="checkbox"
                            id="offerDiscount"
                            label="Offer Discount"
                            checked={serviceData.offerDiscount}
                            onChange={handleCheckedDiscount}
                          />
                        </div>
                      </div>
                    </Fragment>
                  ) : (
                    isServiceOrder === true && (
                      <Fragment>
                        <div className="row">
                          <div className="col-12">
                            <Label className="mt-3"></Label>
                            <CustomInput
                              type="checkbox"
                              id="offerDiscount"
                              label="Offer Discount"
                              checked={serviceData.offerDiscount}
                              onChange={handleCheckedDiscount}
                            />
                          </div>
                        </div>
                      </Fragment>
                    )
                  )}
                  {serviceData.offerDiscount && (
                    <div className="row">
                      <div className="col-5">
                        <Label className="mt-3">Discount </Label>
                        <InputGroup>
                          <Input
                            required
                            name="discount"
                            type="number"
                            value={serviceData.discount}
                            onChange={handleChange}
                          />
                          <InputGroupAddon addonType="prepend">
                            %
                          </InputGroupAddon>
                        </InputGroup>
                      </div>
                      <div className="col-7">
                        <Label className="mt-3">After Discount </Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            $
                          </InputGroupAddon>
                          <Input
                            disabled
                            name="afterDiscount"
                            type="text"
                            value={serviceData.discountedPrice}
                            onChange={handleChange}
                          />
                          <p style={{ padding: '10px', fontWeight: 'bold' }}>
                            to
                          </p>
                          <Input
                            disabled
                            name="afterToDiscount"
                            type="text"
                            value={serviceData.discountedPriceEnd}
                            onChange={handleChange}
                            style={{ height: '42px' }}
                          />
                        </InputGroup>
                      </div>
                    </div>
                  )}
                  {serviceData.type !== 'Retail' &&
                    serviceData.type !== 'InformationOnly' &&
                    serviceData.type !== 'InformationAction' &&
                    serviceData.type !== 'TitleAction' && (
                      <Fragment>
                        <Label className="mt-3">Tax Included in Price? </Label>
                        <Input
                          name="taxIncluded"
                          type="select"
                          onChange={handleChange}
                          value={serviceData.taxIncluded}
                        >
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </Input>
                      </Fragment>
                    )}

                  {/* {isAccommodation === true && serviceData.type !== "Retail" && (
                 <div className="row">
                   <div className="col-6">
                     <Label className="mt-3">Tax Percentage <span style={{ color: "red" }}>*</span></Label>
                     <InputGroup>
                       <Input
                         required
                         name="taxPercentage"
                         type="number"
                         min="0"
                         value={serviceData.taxPercentage}
                         onChange={handleChange}
                       />
                       <InputGroupAddon addonType="prepend">%</InputGroupAddon>
                     </InputGroup>
                   </div>
                   <div className="col-6">
                     <Label className="mt-3">Tax Amount <span style={{ color: "red" }}>*</span></Label>
                     <Input
                       disabled
                       name="taxAmount"
                       type="text"
                       value={serviceData.taxAmount}
                       onChange={handleChange}
                       style={{ height: "42px" }}
                     />
                   </div>
                 </div>
               )} */}
                  {/* {serviceData.type !== 'Retail' && serviceData.type !== 'InformationOnly' &&
                  serviceData.type !== "InformationAction" && serviceData.type !== "InformationPrice" && (
                    <Fragment>
                      <Label className="mt-3">Conditions & Terms</Label>
                      <ReactQuill
                        theme="snow"
                        value={getLocalStatement(serviceData.conditions)}
                        onChange={(content, delta, source) =>
                          handleChangeConditionsArr(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="conditions"
                      />
                    </Fragment>
                  )} */}
                </Fragment>
              )}
            {isAccommodation === true &&
              serviceData.type !== 'Retail' &&
              serviceData.type !== 'InformationOnly' && (
                <Fragment>
                  <Label className="mt-3">Action</Label>
                  <Input
                    type="select"
                    name="bookingMethod"
                    value={serviceData.bookingMethod}
                    onChange={handleChange}
                  >
                    <option value="0">Select</option>
                    <option value="ExternalURL">
                      External URL (Inside Compendium)
                    </option>
                    <option value="ExternalURLNewWindow">
                      External URL (New Window)
                    </option>
                    <option value="aiva">Open aiva Voucher</option>
                    <option value="SubmitForm">Submit Form</option>
                    <option value="EventsCalendar">Show Events Calendar</option>
                    <option value="GuestsPass">Show Guest Pass</option>
                    <option value="ShowRooms">Show Rooms</option>
                    <option value="ConversationFlow">Conversation Flow</option>
                    {/* {id !== undefined ?
                      <Fragment>
                        <option value="ExternalURL">External URL</option>
                        <option value="ExternalURLNewWindow">External URL (New Window)</option>
                        <option value="PromoCode">Promo Code</option>
                        <option value="aiva">aiva</option>
                        <option value="CreateTicket">Create Ticket (Pre Check-in)</option>
                        <option value="CreateTicketInStay">Create Ticket (In Stay)</option>
                        <option value="TakePayment">Take Payment</option>
                        <option value="SubmitForm">Submit Form</option>
                      </Fragment> :
                      <Fragment>
                        <option value="ExternalURL">External URL</option>
                        <option value="ExternalURLNewWindow">External URL (New Window)</option>
                        <option value="SubmitForm">Submit Form</option>
                        <option value="aiva">aiva Voucher</option>
                        <option value="TakePayment">Take Payment (Coming Soon)</option>
                      </Fragment>
                    } */}
                  </Input>
                </Fragment>
              )}
            {serviceData.bookingMethod === 'GuestsPass' && (
              <Fragment>
                <Label className="mt-3">Select Guest Pass</Label>
                <Input
                  type="select"
                  name="voucherId"
                  id="locations"
                  value={serviceData.voucherId}
                  onChange={handleChange}
                >
                  <option value={''}>Select</option>
                  {guestLocation.length > 0 &&
                    guestLocation.map(
                      (item) =>
                        item.title !== '' && (
                          <option value={item.id}>{item.title}</option>
                        )
                    )}
                </Input>
              </Fragment>
            )}
            {isAivaProperty === true &&
            serviceData.type !== 'Media' &&
            serviceData.type !== 'InformationOnly' &&
            serviceData.bookingMethod === 'aiva' ? (
              <Fragment>
                <Label className="mt-3">Select Voucher(s)</Label>
                <Input
                  type="select"
                  name="vouchers"
                  value={serviceData.voucherId}
                  onChange={handleChangeVoucher}
                >
                  <option value={''}>Select</option>
                  {vouchers.length > 0 &&
                    vouchers.map(
                      (item) =>
                        item.name !== '' && (
                          <option value={item.id}>{item.name}</option>
                        )
                    )}
                </Input>
              </Fragment>
            ) : (
              serviceData.type !== 'InformationOnly' &&
              serviceData.bookingMethod === 'aiva' && (
                <div className="text-center p-2 mt-2">
                  <p style={{ fontSize: '15px' }}>
                    <b>aiva</b> is an automated, direct sell voucher system
                    allowing you to offer fully branded vouchers on your
                    website.{' '}
                  </p>
                  <p className="mt-3" style={{ fontSize: '15px' }}>
                    Currently, you do not have an account for <b>aiva</b>. It's
                    quick, inexpensive, simple and smart. Ten minutes is all it
                    takes to sign-up and upload your first voucher.
                  </p>
                  <div
                    className="d-flex"
                    style={{
                      flexDirection: 'column',
                      alignContent: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleLearnMoreAiva()}
                      size="xs"
                    >
                      Learn More <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleSignUpAiva()}
                      size="xs"
                    >
                      Sign Up <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                  </div>
                </div>
              )
            )}
            {serviceData.voucherId !== null &&
              serviceData.voucherId !== '' &&
              serviceData.voucherName !== null &&
              serviceData.voucherName !== '' &&
              serviceData.bookingMethod === 'aiva' && (
                <div className="text-left p-2 mt-2">
                  <span>
                    <a
                      href={
                        `${process.env.REACT_APP_VOUCHERAIVA_URL}/vhp?id=` +
                        serviceData.voucherId
                      }
                      rel="noopener noreferrer"
                      target="_blank"
                      style={{ textDecoration: 'underline', fontWeight: '600' }}
                    >
                      Click here
                    </a>{' '}
                    to view the voucher
                  </span>
                  <br />
                </div>
              )}
            {isServiceOrder === true && (
              <Fragment>
                <Label className="mt-3">Order/Buy Method</Label>
                <Input
                  type="select"
                  name="bookingMethod"
                  value={serviceData.bookingMethod}
                  onChange={handleChange}
                >
                  <option value="0">Select</option>
                  <option value="ExternalURL">External URL</option>
                  <option value="PromoCode">Promo Code</option>
                  <option value="aiva">aiva</option>
                  <option value="CreateTicket">Create Ticket</option>
                  <option value="TakePayment">Take Payment</option>
                </Input>
              </Fragment>
            )}
            {serviceData.bookingMethod === 'PromoCode' && (
              <div className="row">
                <div className="col-12">
                  <Label className="mt-3">Promo Code</Label>
                  <Input
                    type="text"
                    onChange={handleChangeArr}
                    value={serviceData.promoCode[0].statement}
                    name="promoCode"
                    placeholder="Promo Code"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">External Link (Url)</Label>
                  <Input
                    type="text"
                    onChange={handleChangeArr}
                    value={serviceData.externalUrl[0].statement}
                    name="externalUrl"
                    placeholder="External Link (Url)"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">Instructions</Label>
                  <Input
                    type="textarea"
                    onChange={handleChangeInstruction}
                    value={getLocalStatement(serviceData.instructions)}
                    name="instructions"
                    placeholder="Instructions"
                  />
                </div>
              </div>
            )}
            {serviceData.bookingMethod === 'ExternalURL' ||
            serviceData.bookingMethod === 'ExternalURLNewWindow' ? (
              <div className="row">
                <div className="col-12">
                  <Label className="mt-3">External Link (Url)</Label>
                  <Input
                    type="text"
                    onChange={handleChangeArr}
                    value={serviceData.externalUrl[0].statement}
                    name="externalUrl"
                    placeholder="External Link (Url)"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">Instructions</Label>
                  <Input
                    type="textarea"
                    onChange={handleChangeInstruction}
                    value={getLocalStatement(serviceData.instructions)}
                    name="instructions"
                    placeholder="Instructions"
                  />
                </div>
                <div className="col-12">
                  <Label className="mt-3">Action Button Text</Label>
                  <Input
                    type="text"
                    value={getLocalStatement(serviceData.submitButtonText)}
                    onChange={handleChangeSubmitButtonText}
                    name="submitButtonText"
                    placeholder="Action Button Text"
                  />
                </div>
              </div>
            ) : null}
            {serviceData.bookingMethod === 'SubmitForm' ? (
              <Fragment>
                <Label className="mt-3">Select Forms </Label>
                <Input
                  type="select"
                  name="forms"
                  value={
                    serviceData.forms.length > 0
                      ? getFormName(serviceData.forms)
                      : ''
                  }
                  onChange={handleChangeForm}
                >
                  <option value="">Select</option>
                  {formsData &&
                    formsData.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                </Input>
                {serviceData.forms.length > 0 && (
                  <Fragment>
                    <Label className="mt-3">Action Button Text</Label>
                    <Input
                      type="text"
                      value={getLocalStatement(serviceData.submitButtonText)}
                      onChange={handleChangeSubmitButtonText}
                      name="submitButtonText"
                      placeholder="Action Button Text"
                    />
                  </Fragment>
                )}
              </Fragment>
            ) : null}
            {serviceData.bookingMethod === 'EventsCalendar' ? (
              <Fragment>
                {/* <Label className="mt-3">Select Events Calendar </Label>
                <Input
                  type="select"
                  name="events"
                  value={serviceData.formId}
                  onChange={handleChangeEventsCalendar}
                >
                  <option value="">Select</option>
                  {eventsData && eventsData.map((item) =>
                    <option value={item.id}>{item.title}</option>
                  )}
                </Input>
                {serviceData.formId !== "" &&
                  <Fragment> */}
                <Label className="mt-3">Button Text</Label>
                <Input
                  type="text"
                  value={getLocalStatement(serviceData.submitButtonText)}
                  onChange={handleChangeSubmitButtonText}
                  name="submitButtonText"
                  placeholder="Submit Form Text"
                />
                {/* </Fragment>
                } */}
              </Fragment>
            ) : null}
            {serviceData.bookingMethod === 'ConversationFlow' ? (
              <Fragment>
                <Label className="mt-3">Select Conversational Flow</Label>
                <Input
                  type="select"
                  name="conversationFlow"
                  value={
                    serviceData?.conversationFlow?.length > 0
                      ? getFormName(serviceData.conversationFlow)
                      : ''
                  }
                  onChange={handleChangeConFlow}
                >
                  <option value="">Select</option>
                  {conversationFlowList &&
                    conversationFlowList.map((item, i) => (
                      <option value={item.id} key={i}>
                        {item.name}
                      </option>
                    ))}
                </Input>
              </Fragment>
            ) : null}
            {serviceData.type !== 'aivaVoucher' &&
              serviceData.bookingMethod !== 'aiva' &&
              isHostedPage !== undefined &&
              isHostedPage && (
                <Fragment>
                  <Label className="mt-3">Hosted Service Url</Label>
                  <Input
                    type="text"
                    onChange={handleChangeArr}
                    value={
                      isServiceOrder === true
                        ? process.env.REACT_APP_SERVICE_URL +
                          '/gshp?id=' +
                          serviceData.id
                        : process.env.REACT_APP_SERVICE_URL +
                          '/info?id=' +
                          serviceData.id
                    }
                    name="directLink"
                    disabled={true}
                  />
                </Fragment>
              )}
            {serviceData.type === 'aivaVoucher' &&
            serviceData.bookingMethod === 'aiva' ? null : (
              <Fragment>
                <Label className="mt-3">Image</Label>
                <div className="text-center form-control">
                  {serviceData.imageLink != '' ? (
                    <div className="thumbnail">
                      <img
                        className="list-thumbnail responsive border-0"
                        src={serviceData.imageLink}
                      />
                      <a
                        href="#/"
                        className="remove"
                        data-dz-remove
                        onClick={() => handleRemoveImage()}
                      >
                        {' '}
                        <i className="glyph-icon simple-icon-trash" />{' '}
                      </a>
                    </div>
                  ) : (
                    ''
                  )}

                  <Button
                    color="secondary"
                    className="mt-1"
                    onClick={togglegallery}
                  >
                    <IntlMessages id="dashboards.browsegallery" />
                  </Button>
                </div>
                <div className="mt-2">
                  <CustomInput
                    type="checkbox"
                    id="useImageAsVideoThumbnail"
                    label="Use image as video thumbnail"
                    checked={serviceData.useImageAsVideoThumbnail || false}
                    onChange={(e) =>
                      setServiceData({
                        ...serviceData,
                        useImageAsVideoThumbnail: e.target.checked,
                      })
                    }
                  />
                </div>

                <Label className="mt-3">Icon</Label>
                <div className="text-center form-control">
                  {serviceData.iconLink != '' ? (
                    <div className="thumbnail">
                      <img
                        className="list-thumbnail responsive border-0"
                        src={serviceData.iconLink}
                      />
                      <a
                        href="#/"
                        className="remove"
                        data-dz-remove
                        onClick={() => handleRemoveIcon()}
                      >
                        {' '}
                        <i className="glyph-icon simple-icon-trash" />{' '}
                      </a>
                    </div>
                  ) : (
                    ''
                  )}

                  <Button
                    color="secondary"
                    className="mt-1"
                    onClick={toggleIconGallery}
                  >
                    Choose your icon
                  </Button>
                </div>
                <Label className="mt-3">Video</Label>
                <div className="text-center form-control">
                  <Row className="mb-2 text-left">
                    {serviceData?.media && serviceData.media != '' ? (
                      <div className="thumbnail">
                        <iframe
                          className="list-thumbnail responsive border-0"
                          src={serviceData?.media}
                        />
                        <a
                          href="#/"
                          className="remove"
                          data-dz-remove
                          onClick={() => handleRemoveMedia()}
                        >
                          {' '}
                          <i className="glyph-icon simple-icon-trash" />{' '}
                        </a>
                      </div>
                    ) : (
                      ''
                    )}
                  </Row>
                  <Button
                    color="secondary"
                    className="mt-1"
                    onClick={handleFileUploadToggle}
                  >
                    Upload
                  </Button>
                </div>
                <Fragment>
                  <Label className="mt-3">Video Link</Label>
                  <Input
                    type="text"
                    onChange={(e) =>
                      setServiceData({ ...serviceData, media: e.target.value })
                    }
                    value={serviceData?.media}
                    name="media"
                  />
                </Fragment>
              </Fragment>
            )}
            <Appearance
              appearance={serviceData.appearance}
              handleAppearance={handleAppearance}
            ></Appearance>
            <div className="row">
              <div
                className="col-12"
                style={{
                  marginTop: '1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <CustomInput
                  type="checkbox"
                  id="is_globel"
                  label="Make this item globel i.e visible across all properties"
                  checked={serviceData.isGlobal}
                  onChange={handleCheckedGlobal}
                />{' '}
                <i className="demo-icon simple-icon-info" id="globeltip"></i>
                <Tooltip
                  placement="right"
                  isOpen={globelToolTip}
                  target="globeltip"
                  toggle={toggleGlobelToolTip}
                >
                  <p className="text-left">
                    This item will be visible across all the properties in your
                    group. Any changes will reflect across all the properties
                    where you are showing this item.
                    <br />
                    <br />
                    You can change the status to “Inactive” at property level,
                    if you don’t want to show for a particular property.
                  </p>
                </Tooltip>
              </div>
            </div>
          </ModalBody>
        )}
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          {id && (
            <Button color="danger" onClick={toggle}>
              Delete
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={addTagModel}
        toggle={() => {
          setAddTagModel(!addTagModel);
        }}
      >
        <ModalHeader toggle={() => setAddTagModel(!addTagModel)}>
          {isCategoryTag ? 'Category' : 'Membership Group'} Tag
        </ModalHeader>
        <ModalBody>
          <div className="margin-0">
            <Input
              type="text"
              name="ownTag"
              value={ownTag}
              onChange={(e) => {
                setOwnTag(e.target.value);
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => handleCustomisationsTag(ownTag)}
          >
            Add
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setAddTagModel(!addTagModel);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      {addCategoryTagModel && (
        <CategoryTag
          visible={addCategoryTagModel}
          toggle={() => setAddCategoryTagModel(!addCategoryTagModel)}
          handleOwnCategoryTag={
            id === undefined ? handleOwnCategoryTag : handleUpdateOwnCategoryTag
          }
          allCategoryData={allAddonCategoryData}
          isEdit={isEditCategory}
          propertyId={propertyId}
          languageCode={languageCode}
        ></CategoryTag>
      )}
      <Modal
        isOpen={errorModel.isVisible}
        toggle={() => {
          setErrorModel({
            ...errorModel,
            isVisible: !errorModel.isVisible,
            msg: '',
          });
        }}
      >
        <ModalBody>
          <div className="margin-0">
            <p>{errorModel.msg}</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() =>
              setErrorModel({
                ...errorModel,
                isVisible: !errorModel.isVisible,
                msg: '',
              })
            }
          >
            OK
          </Button>
        </ModalFooter>
      </Modal>

      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
      {generateDeleteButton()}
      {ImageGalleryButton()}
      {IconGalleryButton()}
      {UploadMedia()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, domains } = settings;
  return {
    propertyId,
    locale,
    domains,
  };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewService));
